/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { Menu, X } from "lucide-react";
import wedifyLogo from "../../assets/logo/wedify-logo-color-hori.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const sectionIds = {
    Home: "home-section",
    Fitur: "features-section",
    Tema: "theme-section",
    Bundle: "bundle-section",
    FAQ: "faq-section",
    Testimoni: "testimonial-section",
  };

  const handleNavigation = (section) => {
    const elementId = sectionIds[section];
    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        setIsOpen(false);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <nav className="w-full fixed top-0 left-0 flex items-center px-6 lg:px-20 py-3 shadow-md bg-white z-50">
      <a href="/" className="flex-shrink-0">
        <img src={wedifyLogo} alt="Wedify Logo" className="w-[120px] h-auto" />
      </a>

      <div className="hidden lg:flex items-center ml-auto">
        <ul className="flex gap-10 text-[16px] font-normal text-[#010203] font-montserrat">
          {["Home", "Fitur", "Tema", "Bundle", "FAQ", "Testimoni"].map(
            (item) => (
              <li
                key={item}
                className="cursor-pointer hover:text-[#F59581] transition"
                onClick={() => handleNavigation(item)}
              >
                {item}
              </li>
            )
          )}
        </ul>
        <div className="flex items-center gap-3">
          <div className="w-[1px] h-6 mx-4 bg-[#E0E0E0]"></div>
          <Link
            to="/login"
            className="px-3 py-1 border border-[#F59581] text-[#F59581] rounded-md hover:bg-[#F59581] hover:text-white transition"
          >
            Masuk
          </Link>
          <Link
            to="/register"
            className="px-3 py-1 bg-[#F59581] text-white rounded-md hover:bg-opacity-80 transition text-center"
          >
            Daftar
          </Link>
        </div>
      </div>

      <button
        className="lg:hidden ml-auto text-[#010203]"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <X size={30} /> : <Menu size={30} />}
      </button>

      <div
        ref={menuRef}
        className={`lg:hidden fixed top-0 left-0 w-full bg-white shadow-md transform transition-all duration-300 ease-in-out flex flex-col items-center gap-5 py-6 ${
          isOpen
            ? "translate-y-0 opacity-100 visible"
            : "-translate-y-full opacity-0 invisible"
        }`}
      >
        {["Home", "Fitur", "Tema", "Bundle", "FAQ", "Testimoni"].map((item) => (
          <a
            key={item}
            className="cursor-pointer hover:text-[#F59581] transition"
            onClick={() => {
              handleNavigation(item);
              setIsOpen(false);
            }}
          >
            {item}
          </a>
        ))}
        <Link
          to="/login"
          className="w-[80%] py-2 text-[14px] border border-[#F59581] text-[#F59581] rounded-md hover:bg-[#F59581] hover:text-white transition text-center"
          onClick={() => setIsOpen(false)}
        >
          Masuk
        </Link>
        <Link
          to="/register"
          className="w-[80%] py-2 text-[14px] bg-[#F59581] text-white rounded-md hover:bg-opacity-80 transition text-center"
          onClick={() => setIsOpen(false)}
        >
          Daftar
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
